export default "__VITE_ASSET__Ba89Y57X__"